<template>
  <div class="pa-10">
    <div class="mb-6">
      <h1 style="font-size: 18pt; font-weight: 700; letter-spacing: -0.5px">
        Knowledge
      </h1>
      <p style="font-size: 10pt; color: #71717a">
        Your reference materials, articles and documents.
      </p>
    </div>

    <div
      class="d-flex align-center justify-space-between mb-4"
      style="gap: 12px"
    >
      <div class="d-flex align-center" style="gap: 8px">
        <v-text-field
          v-model="search"
          placeholder="Filter items..."
          density="compact"
          variant="outlined"
          hide-details
          prepend-inner-icon="mdi-magnify"
          style="width: 260px; border-radius: 6px; font-size: 10pt"
          class="shadcn-input"
        />
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="outlined"
              size="small"
              class="text-none font-weight-medium shadcn-btn-outline"
              prepend-icon="mdi-plus-circle-outline"
            >
              Content Pillar
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              v-for="t in typeOptions"
              :key="t.value"
              @click="toggleTypeFilter(t.value)"
            >
              <template v-slot:prepend>
                <v-checkbox-btn
                  :model-value="selectedTypes.includes(t.value)"
                  density="compact"
                  hide-details
                  class="mr-2"
                />
              </template>
              <v-list-item-title style="font-size: 10pt">{{
                t.value
              }}</v-list-item-title>
              <v-list-item-subtitle style="font-size: 9pt">{{
                t.subtitle
              }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="outlined"
              size="small"
              class="text-none font-weight-medium shadcn-btn-outline"
              prepend-icon="mdi-plus-circle-outline"
            >
              Source
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              v-for="src in sourceOptions"
              :key="src"
              @click="toggleSourceFilter(src)"
            >
              <template v-slot:prepend>
                <v-checkbox-btn
                  :model-value="selectedSources.includes(src)"
                  density="compact"
                  hide-details
                />
              </template>
              <v-list-item-title style="font-size: 10pt">{{
                src
              }}</v-list-item-title>
            </v-list-item>
            <v-divider class="my-2"></v-divider>
            <v-list-item @click="addSourceDialog = true">
              <v-list-item-title style="font-size: 10pt">
                Manage Sources
              </v-list-item-title>
              <v-list-item-subtitle style="font-size: 9pt">
                Add a website URL as a source</v-list-item-subtitle
              >
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="outlined"
              size="small"
              class="text-none font-weight-medium shadcn-btn-outline"
              prepend-icon="mdi-plus-circle-outline"
            >
              Status
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              v-for="s in statusOptions"
              :key="s.value"
              @click="toggleStatusFilter(s.value)"
            >
              <template v-slot:prepend>
                <v-checkbox-btn
                  :model-value="selectedStatuses.includes(s.value)"
                  density="compact"
                  hide-details
                  class="mr-2"
                />
              </template>
              <v-list-item-title style="font-size: 10pt">{{
                s.value
              }}</v-list-item-title>
              <v-list-item-subtitle style="font-size: 9pt">{{
                s.label
              }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="d-flex" style="gap: 8px">
        <v-btn
          variant="outlined"
          size="small"
          class="text-none font-weight-medium shadcn-btn-outline"
          prepend-icon="mdi-file-document-multiple-outline"
          :disabled="selected.length === 0"
          @click="openConvertToPostsFromSelection"
        >
          Convert to posts
        </v-btn>
        <v-btn
          v-show="selected.length > 0"
          icon
          variant="outlined"
          size="small"
          class="shadcn-btn-outline"
          color="error"
          @click="deleteSelected"
        >
          <v-icon size="18">mdi-delete-outline</v-icon>
        </v-btn>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              color="#18181b"
              variant="flat"
              size="small"
              class="text-none font-weight-medium"
              style="border-radius: 6px; letter-spacing: 0"
              prepend-icon="mdi-upload"
              height="32"
            >
              Add Item
            </v-btn>
          </template>
          <v-list density="compact" style="min-width: 200px">
            <v-list-item @click="triggerFileUpload">
              <template v-slot:prepend>
                <v-icon size="18" color="#71717a"
                  >mdi-file-upload-outline</v-icon
                >
              </template>
              <v-list-item-title style="font-size: 10pt"
                >Upload file</v-list-item-title
              >
              <v-list-item-subtitle style="font-size: 9pt"
                >PDF, document, image...</v-list-item-subtitle
              >
            </v-list-item>
            <v-list-item @click="addItemUrlDialog = true">
              <template v-slot:prepend>
                <v-icon size="18" color="#71717a">mdi-link-variant</v-icon>
              </template>
              <v-list-item-title style="font-size: 10pt"
                >Insert URL</v-list-item-title
              >
              <v-list-item-subtitle style="font-size: 9pt"
                >Blog, article, webpage...</v-list-item-subtitle
              >
            </v-list-item>
          </v-list>
        </v-menu>
        <input
          ref="fileInput"
          type="file"
          accept=".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg,.webp,.csv,.xlsx,.xls"
          class="d-none"
          @change="onFileSelected"
        />
      </div>
    </div>

    <v-dialog v-model="addSourceDialog" max-width="520" persistent>
      <v-card
        style="border-radius: 12px; border: 1px solid hsl(214.3 31.8% 91.4%)"
      >
        <v-card-title
          class="pt-5 px-6"
          style="font-size: 12pt; font-weight: 600; letter-spacing: -0.3px"
        >
          Add Source
        </v-card-title>
        <v-card-text class="px-6 pb-2">
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 16px">
            Enter a website URL or LinkedIn profile to import as a knowledge
            base source.
          </p>
          <v-text-field
            v-model="newSourceUrl"
            placeholder="example.com or linkedin.com/in/username"
            density="compact"
            variant="outlined"
            hide-details="auto"
            :error-messages="newSourceError"
            prepend-inner-icon="mdi-link-variant"
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 10px"
            @keydown.enter="submitSource"
          />
          <!-- <p style="font-size: 10pt; color: #71717a; margin-bottom: 6px">
            Source type
          </p>
          <v-select
            v-model="newSourceType"
            :items="sourceTypeOptions"
            item-title="label"
            item-value="value"
            placeholder="Select source type"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt"
          /> -->
          <div v-if="existingSources.length > 0" class="mt-4">
            <p
              style="
                font-size: 9pt;
                font-weight: 500;
                color: #71717a;
                margin-bottom: 8px;
              "
            >
              Connected sources
            </p>
            <div class="d-flex flex-wrap" style="gap: 6px">
              <v-chip
                v-for="src in existingSources"
                :key="src.uid"
                size="small"
                variant="outlined"
                closable
                @click:close="removeSource(src)"
                style="font-size: 9pt; border-color: hsl(214.3 31.8% 91.4%)"
              >
                <v-icon start size="14" color="#71717a">
                  {{
                    src.type === "LinkedIn Profile" ? "mdi-linkedin" : "mdi-web"
                  }}
                </v-icon>
                {{ src.title }}
              </v-chip>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-3">
          <v-spacer />
          <v-btn
            variant="outlined"
            size="small"
            class="text-none font-weight-medium shadcn-btn-outline"
            @click="closeSourceDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#18181b"
            variant="flat"
            size="small"
            class="text-none font-weight-medium"
            style="border-radius: 6px; letter-spacing: 0"
            :loading="newSourceLoading"
            :disabled="!newSourceUrl"
            @click="submitSource"
          >
            Add Source
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="uploadTypeDialog" max-width="520" persistent>
      <v-card
        style="border-radius: 12px; border: 1px solid hsl(214.3 31.8% 91.4%)"
      >
        <v-card-title
          class="pt-5 px-6"
          style="font-size: 12pt; font-weight: 600; letter-spacing: -0.3px"
        >
          Upload file
        </v-card-title>
        <v-card-text class="px-6 pb-2">
          <p
            v-if="pendingFile"
            style="font-size: 10pt; color: #71717a; margin-bottom: 8px"
          >
            File: <strong>{{ pendingFile.name }}</strong>
          </p>
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Title
          </p>
          <v-text-field
            v-model="uploadFileTitle"
            placeholder="Give this item a title"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            What type of content is this?
          </p>
          <v-select
            v-model="uploadFileType"
            :items="typeOptions"
            item-title="label"
            item-value="value"
            placeholder="Select type"
            no-data-text="No types"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt"
            :disabled="uploading"
          />
          <v-progress-linear
            v-if="uploading"
            :model-value="uploadProgress"
            color="#18181b"
            height="6"
            rounded
            class="mt-4"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-3">
          <v-spacer />
          <v-btn
            variant="outlined"
            size="small"
            class="text-none font-weight-medium shadcn-btn-outline"
            :disabled="uploading"
            @click="closeUploadTypeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#18181b"
            variant="flat"
            size="small"
            class="text-none font-weight-medium"
            style="border-radius: 6px; letter-spacing: 0"
            :disabled="!uploadFileType || !uploadFileTitle?.trim() || uploading"
            @click="submitUploadFile"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addItemUrlDialog" max-width="520" persistent>
      <v-card
        style="border-radius: 12px; border: 1px solid hsl(214.3 31.8% 91.4%)"
      >
        <v-card-title
          class="pt-5 px-6"
          style="font-size: 12pt; font-weight: 600; letter-spacing: -0.3px"
        >
          Insert URL
        </v-card-title>
        <v-card-text class="px-6 pb-2">
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 16px">
            Enter the URL of a blog post, article or webpage to add to your
            knowledge base.
          </p>
          <v-text-field
            v-model="newItemUrl"
            placeholder="https://example.com/blog/interesting-article"
            density="compact"
            variant="outlined"
            hide-details="auto"
            :error-messages="newItemUrlError"
            prepend-inner-icon="mdi-link-variant"
            class="shadcn-input"
            style="font-size: 10pt"
            @keydown.enter="submitItemUrl"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-3">
          <v-spacer />
          <v-btn
            variant="outlined"
            size="small"
            class="text-none font-weight-medium shadcn-btn-outline"
            @click="closeItemUrlDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#18181b"
            variant="flat"
            size="small"
            class="text-none font-weight-medium"
            style="border-radius: 6px; letter-spacing: 0"
            :disabled="!newItemUrl"
            @click="submitItemUrl"
          >
            Add Item
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="convertToPostsDialog" max-width="560" persistent>
      <v-card
        style="border-radius: 12px; border: 1px solid hsl(214.3 31.8% 91.4%)"
      >
        <v-card-title
          class="pt-5 px-6"
          style="font-size: 12pt; font-weight: 600; letter-spacing: -0.3px"
        >
          Convert to posts
        </v-card-title>
        <v-card-text class="px-6 pb-2">
          <p
            v-if="convertItems.length > 0"
            style="font-size: 10pt; color: #71717a; margin-bottom: 16px"
          >
            <template v-if="convertItems.length === 1">
              Split <strong>{{ convertItems[0].title }}</strong> into multiple
              posts.
            </template>
            <template v-else>
              Split <strong>{{ convertItems.length }} items</strong> into
              multiple posts.
            </template>
          </p>
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            How many posts to split this content into
          </p>
          <v-text-field
            v-model.number="convertPostCount"
            type="number"
            placeholder="3"
            density="compact"
            variant="outlined"
            hide-details
            min="1"
            max="20"
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Any specific instructions for the AI writing model
          </p>
          <v-textarea
            v-model="convertAiInstructions"
            placeholder="e.g. Keep each post under 150 words. Use a conversational tone. Focus on one key takeaway per post."
            density="compact"
            variant="outlined"
            hide-details
            rows="3"
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Which category to add posts to
          </p>
          <v-select
            v-model="convertCategory"
            :items="categories"
            item-title="name"
            item-value="uid"
            placeholder="Select category"
            no-data-text="No categories setup"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          >
            <template v-slot:item="{ props }">
              <v-list-item v-bind="props">
                <template v-slot:prepend>
                  <v-icon size="14" :color="props.color">mdi-circle</v-icon>
                </template>
              </v-list-item>
            </template>
          </v-select>
          <p
            style="
              font-size: 9pt;
              font-weight: 500;
              color: #71717a;
              margin-bottom: 8px;
            "
          >
            Media for posts
          </p>
          <v-radio-group
            v-model="convertMediaOption"
            hide-details
            density="compact"
            class="convert-radio-group"
          >
            <v-radio value="use_file" color="#18181b">
              <template v-slot:label>
                <span class="convert-radio-label"
                  >Use this file/link as media</span
                >
              </template>
            </v-radio>
            <v-radio value="generate" color="#18181b">
              <template v-slot:label>
                <span class="convert-radio-label"
                  >Generate separate post images</span
                >
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-3">
          <v-spacer />
          <v-btn
            variant="outlined"
            size="small"
            class="text-none font-weight-medium shadcn-btn-outline"
            @click="closeConvertToPosts"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#18181b"
            variant="flat"
            size="small"
            class="text-none font-weight-medium"
            style="border-radius: 6px; letter-spacing: 0"
            :loading="converting"
            :disabled="
              convertItems.length === 0 || !convertCategory || !convertPostCount
            "
            @click="submitConvertToPosts"
          >
            Convert to posts
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editItemDialog" max-width="520" persistent>
      <v-card
        style="border-radius: 12px; border: 1px solid hsl(214.3 31.8% 91.4%)"
      >
        <v-card-title
          class="pt-5 px-6"
          style="font-size: 12pt; font-weight: 600; letter-spacing: -0.3px"
        >
          Edit item
        </v-card-title>
        <v-card-text class="px-6 pb-2">
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Type
          </p>
          <v-select
            v-model="editItem.type"
            :items="typeOptions"
            item-title="label"
            item-value="value"
            placeholder="Select type"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Title
          </p>
          <v-text-field
            v-model="editItem.title"
            placeholder="Item title"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <template v-if="isUrlEditableType(editItem.type)">
            <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
              URL
            </p>
            <v-text-field
              v-model="editItem.url"
              placeholder="https://example.com/blog/article"
              density="compact"
              variant="outlined"
              hide-details
              prepend-inner-icon="mdi-link-variant"
              class="shadcn-input"
              style="font-size: 10pt; margin-bottom: 16px"
            />
          </template>
          <template v-else>
            <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
              Source
            </p>
            <v-text-field
              v-model="editItem.source"
              placeholder="e.g. stix.social/blog or Upload"
              density="compact"
              variant="outlined"
              hide-details
              prepend-inner-icon="mdi-web"
              class="shadcn-input"
              style="font-size: 10pt; margin-bottom: 16px"
            />
          </template>
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Status
          </p>
          <v-select
            v-model="editItem.status"
            :items="statusOptions"
            item-title="value"
            item-value="value"
            placeholder="Select status"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt; margin-bottom: 16px"
          />
          <p style="font-size: 10pt; color: #71717a; margin-bottom: 8px">
            Priority
          </p>
          <v-select
            v-model="editItem.priority"
            :items="priorityOptions"
            item-title="label"
            item-value="value"
            placeholder="Select priority"
            density="compact"
            variant="outlined"
            hide-details
            class="shadcn-input"
            style="font-size: 10pt"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-3">
          <v-spacer />
          <v-btn
            variant="outlined"
            size="small"
            class="text-none font-weight-medium shadcn-btn-outline"
            @click="closeEditItem"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#18181b"
            variant="flat"
            size="small"
            class="text-none font-weight-medium"
            style="border-radius: 6px; letter-spacing: 0"
            @click="submitEditItem"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card
      flat
      style="
        border: 1px solid hsl(214.3 31.8% 91.4%);
        border-radius: 0.5rem;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        overflow: hidden;
      "
    >
      <v-table density="compact" class="shadcn-table">
        <thead>
          <tr>
            <th style="width: 40px">
              <v-checkbox-btn
                :model-value="allSelected"
                :indeterminate="someSelected && !allSelected"
                @update:model-value="toggleAll"
                density="compact"
                hide-details
              />
            </th>

            <th class="table-header">Title</th>
            <th class="table-header" style="width: 140px">
              <span class="d-flex align-center" style="gap: 4px">
                Status
                <v-icon size="14" color="#71717a"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </span>
            </th>
            <th class="table-header" style="width: 160px">
              <span class="d-flex align-center" style="gap: 4px">
                Source
                <v-icon size="14" color="#71717a"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </span>
            </th>
            <th class="table-header" style="width: 140px">
              <span class="d-flex align-center" style="gap: 4px">
                Date
                <v-icon size="14" color="#71717a"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </span>
            </th>
            <th class="table-header" style="width: 120px">
              <span class="d-flex align-center" style="gap: 4px">
                Priority
                <v-icon size="14" color="#71717a"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </span>
            </th>
            <th style="width: 40px"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in filteredItems"
            :key="getItemId(item)"
            class="table-row"
          >
            <td>
              <v-checkbox-btn
                :model-value="selected.includes(getItemId(item))"
                @update:model-value="toggleSelect(getItemId(item))"
                density="compact"
                hide-details
              />
            </td>

            <td>
              <div class="d-flex align-center" style="gap: 8px">
                <v-chip
                  size="x-small"
                  variant="outlined"
                  color="primary"
                  class="text-none"
                  style="font-size: 8pt"
                >
                  {{ item.type }}
                </v-chip>
                <span
                  style="
                    display: flex;
                    flex-direction: column;
                    max-width: 420px;
                    margin: 10px 0;
                  "
                >
                  <span
                    style="
                      font-size: 10pt;
                      font-weight: 500;
                      color: #09090b;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.title }}
                  </span>
                  <span
                    v-if="item.url"
                    style="
                      font-size: 9pt;
                      color: #71717a;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.url }}
                  </span>
                </span>
              </div>
            </td>
            <td>
              <div class="d-flex align-center" style="gap: 6px">
                <v-icon size="14" :color="statusColor(item.status)">{{
                  statusIcon(item.status)
                }}</v-icon>
                <span style="font-size: 10pt; color: #09090b">{{
                  item.status
                }}</span>
              </div>
            </td>
            <td>
              <div class="d-flex align-center" style="gap: 6px">
                <v-icon size="14" color="#71717a" v-if="item.source"
                  >mdi-web</v-icon
                >
                <span style="font-size: 10pt; color: #71717a">{{
                  item.source || "-"
                }}</span>
              </div>
            </td>
            <td>
              <span style="font-size: 10pt; color: #71717a">
                {{ formatDate(item.created_at) }}
              </span>
            </td>
            <td>
              <div class="d-flex align-center" style="gap: 6px">
                <v-icon size="14" :color="priorityColor(item.priority)">{{
                  priorityIcon(item.priority)
                }}</v-icon>
                <span style="font-size: 10pt; color: #09090b">{{
                  item.priority
                }}</span>
              </div>
            </td>
            <td>
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" size="x-small">
                    <v-icon size="16" color="#71717a"
                      >mdi-dots-horizontal</v-icon
                    >
                  </v-btn>
                </template>
                <v-list density="compact" style="min-width: 140px">
                  <v-list-item link>
                    <v-list-item-title
                      style="font-size: 10pt"
                      @click="openItem(item)"
                    >
                      Open</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link @click="openEditItem(item)">
                    <v-list-item-title style="font-size: 10pt"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link @click="openPosts(item)">
                    <v-list-item-title style="font-size: 10pt">
                      Show posts
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item link @click="openConvertToPosts(item)">
                    <v-list-item-title style="font-size: 10pt"
                      >Convert to posts</v-list-item-title
                    >
                  </v-list-item>
                  <v-divider />
                  <v-list-item link @click="deleteKnowledgeItem(item)">
                    <v-list-item-title style="font-size: 10pt; color: #dc2626"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-if="filteredItems.length === 0">
            <td colspan="7" class="text-center pa-8">
              <p style="font-size: 10pt; color: #71717a">
                No items match your filters.
              </p>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <div
      class="d-flex align-center justify-space-between mt-3"
      style="font-size: 10pt; color: #71717a"
    >
      <span
        >{{ selected.length }} of {{ filteredItems.length }} row(s)
        selected.</span
      >
      <span>{{ filteredItems.length }} items total</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
export default {
  name: "KnowledgeBase",

  data() {
    return {
      converting: false,
      search: "",
      selected: [],
      selectedTypes: [],
      selectedStatuses: [],
      selectedSources: [],
      addSourceDialog: false,
      newSourceUrl: "",
      newSourceError: "",
      newSourceLoading: false,
      newSourceType: "Website",
      addItemUrlDialog: false,
      newItemUrl: "",
      newItemUrlError: "",
      uploadTypeDialog: false,
      pendingFile: null,
      uploadFileType: null,
      uploadFileTitle: "",
      uploading: false,
      uploadProgress: 0,
      convertToPostsDialog: false,
      convertItems: [],
      convertPostCount: 3,
      convertAiInstructions: "",
      convertCategory: null,
      convertMediaOption: "generate",
      typeOptions: [
        {
          label: "Thought Leadership",
          subtitle: "takes, perspectives, opinions on industry",
          value: "Thought Leadership",
        },
        {
          label: "Customer Success",
          subtitle: "Case studies, client wins, testimonials",
          value: "Customer Success",
        },
        {
          label: "Product Insights",
          subtitle: "Feature updates, how-tos, tips",
          value: "Product Insights",
        },
        {
          label: "Industry Trends",
          subtitle: "News, research, data points",
          value: "Industry Trends",
        },
        {
          label: "Team / Culture",
          subtitle: "Hiring, values, behind-the-scenes",
          value: "Team / Culture",
        },
      ],
      sourceTypeOptions: [
        {
          label: "Website",
          value: "Website",
        },
        // {
        //   label: "LinkedIn Profile",
        //   value: "LinkedIn Profile",
        // },
      ],
      statusOptions: [
        {
          label: "Just imported, no posts generated yet",
          value: "New",
        },
        {
          label: "Stix is currently extracting and generating posts from it",
          value: "Processing",
        },
        // {
        //   label: "Posts have been generated and are in rotation",
        //   value: "Active",
        // },
        // {
        //   label: "Source item is paused, its posts won't be scheduled",
        //   value: "Paused",
        // },
        // {
        //   label: "Retired from rotation, posts no longer scheduled",
        //   value: "Archived",
        // },
        {
          value: "Converted",
          label: "Posts have been generated",
        },
        {
          label: "Stix flagged it as potentially outdated",
          value: "Needs Review",
        },
      ],
      priorityOptions: [
        { label: "High", value: "High" },
        { label: "Medium", value: "Medium" },
        { label: "Low", value: "Low" },
      ],
      editItemDialog: false,
      editItem: {},
    };
  },
  computed: {
    ...mapState({
      items: (state) => state.knowledge.items || [],
      sources: (state) => state.knowledge.sources || [],
      categories: (state) => state.posts.categories || [],
      userProfile: (state) => state.users.userProfile || {},
    }),
    existingSources() {
      const list = Array.isArray(this.sources) ? this.sources : [];
      return [...list].sort((a, b) => {
        const aTitle = (a.title ?? "").toString().toLowerCase();
        const bTitle = (b.title ?? "").toString().toLowerCase();
        if (aTitle < bTitle) return -1;
        if (aTitle > bTitle) return 1;
        return 0;
      });
    },
    sourceOptions() {
      return [
        ...new Set(this.items.map((i) => i.source).filter(Boolean)),
      ].sort();
    },
    filteredItems() {
      let list = this.items || [];
      if (this.search) {
        const q = this.search.toLowerCase();
        list = list.filter((i) => {
          const title = (i.title ?? "").toString().toLowerCase();
          const id = (i.id ?? i.uid ?? "").toString().toLowerCase();
          return title.includes(q) || id.includes(q);
        });
      }
      if (this.selectedTypes.length > 0) {
        list = list.filter((i) => this.selectedTypes.includes(i.type));
      }
      if (this.selectedStatuses.length > 0) {
        list = list.filter((i) => this.selectedStatuses.includes(i.status));
      }
      if (this.selectedSources.length > 0) {
        list = list.filter((i) => this.selectedSources.includes(i.source));
      }
      return list;
    },
    allSelected() {
      return (
        this.filteredItems.length > 0 &&
        this.filteredItems.every((i) => this.selected.includes(i.id ?? i.uid))
      );
    },
    someSelected() {
      return this.filteredItems.some((i) =>
        this.selected.includes(i.id ?? i.uid),
      );
    },
  },
  methods: {
    async test() {
      const test = httpsCallable(functions, "testPerplexity");
      let res = await test();
      console.log(res.data);
    },
    formatDate(ts) {
      if (!ts) return "-";
      const d = new Date(ts * 1000);
      if (Number.isNaN(d.getTime())) return "-";
      return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    openPosts(item) {
      this.$store.commit("setQuery", {
        status: "all",
        category: null,
        recurring: null,
        search: null,
        knowledge: item.posts,
      });
      this.$router.push("/library");
    },
    deleteKnowledgeItem(item) {
      this.$store.dispatch("deleteKnowledgeItem", item.id ?? item.uid);
      this.$store.commit("setNotification", {
        show: true,
        text: "Item deleted!",
        type: "primary",
        icon: "",
      });
    },
    getItemId(item) {
      return item?.id ?? item?.uid ?? "";
    },
    toggleSelect(id) {
      const idx = this.selected.indexOf(id);
      if (idx >= 0) {
        this.selected.splice(idx, 1);
      } else {
        this.selected.push(id);
      }
    },
    toggleAll(val) {
      if (val) {
        this.selected = this.filteredItems.map((i) => i.id ?? i.uid);
      } else {
        this.selected = [];
      }
    },
    toggleTypeFilter(type) {
      const idx = this.selectedTypes.indexOf(type);
      if (idx >= 0) {
        this.selectedTypes.splice(idx, 1);
      } else {
        this.selectedTypes.push(type);
      }
    },
    toggleStatusFilter(status) {
      const idx = this.selectedStatuses.indexOf(status);
      if (idx >= 0) {
        this.selectedStatuses.splice(idx, 1);
      } else {
        this.selectedStatuses.push(status);
      }
    },
    toggleSourceFilter(source) {
      const idx = this.selectedSources.indexOf(source);
      if (idx >= 0) {
        this.selectedSources.splice(idx, 1);
      } else {
        this.selectedSources.push(source);
      }
    },
    openItem(item) {
      window.open(item.url || item.src, "_blank");
    },
    normalizeUrl(url) {
      return url
        .trim()
        .replace(/^https?:\/\//, "")
        .replace(/^www\./, "")
        .replace(/\/+$/, "");
    },
    async submitSource() {
      this.newSourceLoading = true;
      if (!this.newSourceUrl) return;
      const normalized = this.normalizeUrl(this.newSourceUrl);
      if (!normalized) {
        this.newSourceError = "Please enter a valid URL.";
        return;
      }
      if (
        Array.isArray(this.sources) &&
        this.sources.some((s) => s.title === normalized)
      ) {
        this.newSourceError = "This source is already connected.";
        return;
      }

      await this.$store.dispatch("addSource", {
        source: this.newSourceUrl,
        title: normalized,
        type: this.newSourceType,
        created_at: Math.round(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        status: "New",
        workspace: this.userProfile.workspace,
      });
      this.newSourceLoading = false;
      this.newSourceUrl = "";
      this.newSourceError = "";
      this.newSourceType = "Website";
      this.addSourceDialog = false;
    },
    removeSource(source) {
      if (!source || !source.uid) return;
      this.$store.dispatch("deleteSource", source.uid);
      if (!Array.isArray(this.sources)) return;
      const idx = this.sources.findIndex((s) => s.uid === source.uid);
      if (idx >= 0) this.sources.splice(idx, 1);
    },
    closeSourceDialog() {
      this.addSourceDialog = false;
      this.newSourceUrl = "";
      this.newSourceError = "";
    },
    triggerFileUpload() {
      this.$refs.fileInput?.click();
    },
    onFileSelected(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      this.pendingFile = file;
      this.uploadFileTitle = file.name;
      this.uploadFileType = null;
      this.uploadTypeDialog = true;
      event.target.value = "";
    },
    async submitUploadFile() {
      if (
        !this.pendingFile ||
        !this.uploadFileType ||
        !this.uploadFileTitle?.trim()
      )
        return;
      this.uploading = true;
      this.uploadProgress = 0;
      try {
        await this.$store.dispatch("addKnowledgeItem", {
          content_pillar: this.uploadFileType,
          title: this.uploadFileTitle.trim(),
          source: "Manual",
          status: "New",
          priority: "Medium",
          created_at: Math.round(Date.now() / 1000),
          created_by: this.userProfile.uid,
          created_by_email: this.userProfile.email,
          file: this.pendingFile,
          deleted: false,
          onProgress: (percent) => {
            this.uploadProgress = Math.round(percent);
          },
        });
        this.$store.dispatch("fetchKnowledgeItems");
        this.uploading = false;
        this.uploadProgress = 0;
        this.closeUploadTypeDialog();
      } catch (e) {
        this.uploading = false;
        this.uploadProgress = 0;
      }
    },
    closeUploadTypeDialog() {
      if (this.uploading) return;
      this.uploadTypeDialog = false;
      this.pendingFile = null;
      this.uploadFileType = null;
      this.uploadFileTitle = "";
      this.uploadProgress = 0;
    },
    isUrlEditableType(type) {
      const urlTypes = [
        "Thought Leadership",
        "Customer Success",
        "Product Insights",
        "Industry Trends",
        "Team / Culture",
      ];
      return urlTypes.includes(type);
    },
    openEditItem(item) {
      this.editItem = { ...item };
      if (this.isUrlEditableType(item.type)) {
        this.editItem.url =
          item.url || (item.source ? "https://" + item.source : "");
      }
      this.editItemDialog = true;
    },
    closeEditItem() {
      this.editItemDialog = false;
      this.editItem = {};
    },
    submitEditItem() {
      const item = { ...this.editItem };
      if (this.isUrlEditableType(item.type) && item.url) {
        const normalized = this.normalizeUrl(item.url);
        if (normalized) {
          const parts = normalized.split("/").filter(Boolean);
          item.source =
            parts.length > 1
              ? parts.slice(0, 2).join("/")
              : parts[0] || normalized;
          item.title = normalized;
        }
      }
      const itemId = item.id ?? item.uid;
      const idx = this.items.findIndex((i) => (i.id ?? i.uid) === itemId);
      if (idx >= 0) {
        this.items.splice(idx, 1, item);
      }
      this.closeEditItem();
    },
    submitItemUrl() {
      if (!this.newItemUrl) return;
      const normalized = this.normalizeUrl(this.newItemUrl);
      if (!normalized) {
        this.newItemUrlError = "Please enter a valid URL.";
        return;
      }

      this.$store.dispatch("addKnowledgeItem", {
        content_pillar: "Thought Leadership",
        title: normalized,
        url: this.newItemUrl,
        source: null,
        deleted: false,
        type: "url",
        status: "New",
        priority: "Medium",
        created_at: Math.round(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        workspace: this.userProfile.workspace,
      });
      //   this.$store.dispatch("fetchKnowledgeItems");
      this.closeItemUrlDialog();
    },
    closeItemUrlDialog() {
      this.addItemUrlDialog = false;
      this.newItemUrl = "";
      this.newItemUrlError = "";
    },
    async deleteSelected() {
      if (this.selected.length === 0) return;
      for (const id of this.selected) {
        await this.$store.dispatch("deleteKnowledgeItem", id);
      }
      this.selected = [];
      await this.$store.dispatch("fetchKnowledgeItems");
    },
    openConvertToPostsFromSelection() {
      if (this.selected.length === 0) return;
      const items = this.selected
        .map((id) => this.items.find((i) => (i.id ?? i.uid) === id))
        .filter(Boolean);
      if (items.length > 0) this.openConvertToPosts(items);
    },
    openConvertToPosts(itemOrItems) {
      this.convertItems = Array.isArray(itemOrItems)
        ? [...itemOrItems]
        : [itemOrItems];
      this.convertPostCount = 3;
      this.convertAiInstructions = "";
      this.convertCategory = null;
      this.convertMediaOption = "generate";
      this.convertToPostsDialog = true;
    },
    closeConvertToPosts() {
      this.convertToPostsDialog = false;
      this.convertItems = [];
    },
    async submitConvertToPosts() {
      if (this.convertItems.length === 0 || !this.convertCategory) return;
      this.$store.dispatch("convertToPosts", {
        items: this.convertItems,
        post_count: this.convertPostCount,
        custom_instructions: this.convertAiInstructions,
        category: this.convertCategory,
        mediaOption: this.convertMediaOption,
        include_images: this.convertMediaOption === "generate",
      });
      this.selected = [];
      this.closeConvertToPosts();
    },
    typeColor(type) {
      const map = {
        "Thought Leadership": "#7c3aed",
        "Customer Success": "#059669",
        "Product Insights": "#2563eb",
        "Industry Trends": "#d97706",
        "Team / Culture": "#0ea5e9",
      };
      return map[type] || "#71717a";
    },
    statusIcon(status) {
      const map = {
        New: "mdi-file-plus-outline",
        Processing: "mdi-timer-sand",
        Active: "mdi-check-circle",
        Paused: "mdi-pause-circle-outline",
        Archived: "mdi-archive-outline",
        "Needs Review": "mdi-alert-circle-outline",
      };
      return map[status] || "mdi-circle-outline";
    },
    statusColor(status) {
      const map = {
        New: "#71717a",
        Processing: "#d97706",
        Active: "#16a34a",
        Paused: "#eab308",
        Archived: "#a1a1aa",
        "Needs Review": "#dc2626",
      };
      return map[status] || "#71717a";
    },
    priorityIcon(priority) {
      const map = {
        High: "mdi-arrow-up",
        Medium: "mdi-arrow-right",
        Low: "mdi-arrow-down",
      };
      return map[priority] || "mdi-arrow-right";
    },
    priorityColor(priority) {
      const map = {
        High: "#dc2626",
        Medium: "#71717a",
        Low: "#a1a1aa",
      };
      return map[priority] || "#71717a";
    },
  },
};
</script>

<style scoped>
/* shadcn-input, shadcn-btn-outline, shadcn-table, table-header, table-row
   are now defined globally in src/styles/shadcn.scss */

.convert-radio-label {
  font-size: 10pt !important;
}
</style>
